import { useModel, useParams } from "bcms-react";
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import "./styles.css";

/**
 * @function ZellePage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for ZellePage
 */
export default function ZellePage(props) {
  const { profileType, RXP17LandingPage } = useParams();
  const config = { profileType: profileType };
  // Branding options needed for captures
  const branding = useModel().branding.options;
  window.BRANDING = { "zle_abi22" : branding.zle_abi22 };

  let hasRXP17LandingPage = RXP17LandingPage ? true : false;
  const RXP17LandingPageProp = hasRXP17LandingPage ? { RXP17LandingPage: RXP17LandingPage } : {};

  return (
    <PageContainer className="zelle-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text={<div className="flex-container"><p>Zelle</p><span className="r-mark">&reg;</span></div>} />
          <div className="iframe-container flex-container flex-horizontal justify-center">
            {/* iFrame for Zelle goes here */}
            <ExternalIframe className="zelle-iframe" demo="ZLE" { ...RXP17LandingPageProp } key="ZellePage"/>      
          </div>    
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}
